// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.btn {
  float: right;
  margin: 10px;
}

.img-fluid {
  float: right;
  margin-left: 20px;
}

#date {
  float: left;
  font-style: italic;
  margin: 20px;
}

.heading {
  text-decoration: underline;
}

.file {
  margin: 20px;
  text-align: center;
}

.fileheading {
  margin-top: 30px;
  text-align: center;
}

.row {
  float: left;
  margin: 20px;
  border: 2px;
}
/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInBkZi1sYXlvdXQuY29tcG9uZW50LnNjc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7RUFDSSxZQUFBO0VBQ0EsWUFBQTtBQUNKOztBQUVDO0VBQ0ksWUFBQTtFQUNBLGlCQUFBO0FBQ0w7O0FBT0M7RUFDSSxXQUFBO0VBQ0Esa0JBQUE7RUFDQSxZQUFBO0FBSkw7O0FBT0c7RUFDQywwQkFBQTtBQUpKOztBQVFHO0VBQ0UsWUFBQTtFQUNBLGtCQUFBO0FBTEw7O0FBUUc7RUFDRSxnQkFBQTtFQUNBLGtCQUFBO0FBTEw7O0FBUUc7RUFDQyxXQUFBO0VBQ0EsWUFBQTtFQUNBLFdBQUE7QUFMSiIsImZpbGUiOiJwZGYtbGF5b3V0LmNvbXBvbmVudC5zY3NzIiwic291cmNlc0NvbnRlbnQiOlsiLmJ0bntcclxuICAgIGZsb2F0OiByaWdodDtcclxuICAgIG1hcmdpbjogMTBweDtcclxuIH1cclxuIFxyXG4gLmltZy1mbHVpZHtcclxuICAgICBmbG9hdDogcmlnaHQ7XHJcbiAgICAgbWFyZ2luLWxlZnQ6IDIwcHg7XHJcbiB9XHJcbiAvLyB0YWJsZSB0aGVhZCB0aCB7IFxyXG4gLy8gICAgIGNvbG9yOiB3aGl0ZTtcclxuIC8vICAgICAgZm9udC1zaXplOjEwcHQ7XHJcbiAvLyAgICAgICBiYWNrZ3JvdW5kLWNvbG9yOiAjM2I1OTk4XHJcbiAvLyAgICAgfVxyXG4gXHJcbiAjZGF0ZXtcclxuICAgICBmbG9hdDogbGVmdDtcclxuICAgICBmb250LXN0eWxlOiBpdGFsaWM7XHJcbiAgICAgbWFyZ2luOjIwcHggO1xyXG4gICB9XHJcbiBcclxuICAgLmhlYWRpbmd7XHJcbiAgICB0ZXh0LWRlY29yYXRpb246IHVuZGVybGluZTtcclxuICAgfVxyXG4gXHJcbiAgXHJcbiAgIC5maWxle1xyXG4gICAgIG1hcmdpbjogMjBweDtcclxuICAgICB0ZXh0LWFsaWduOiBjZW50ZXI7XHJcbiAgIH1cclxuIFxyXG4gICAuZmlsZWhlYWRpbmd7XHJcbiAgICAgbWFyZ2luLXRvcDogMzBweDtcclxuICAgICB0ZXh0LWFsaWduOiBjZW50ZXI7XHJcbiBcclxuICAgfVxyXG4gICAucm93e1xyXG4gICAgZmxvYXQ6IGxlZnQ7XHJcbiAgICBtYXJnaW46IDIwcHg7XHJcbiAgICBib3JkZXI6IDJweDtcclxuICAgfSJdfQ== */`, "",{"version":3,"sources":["webpack://./src/app/pages/small-molecule/pdf-layout/pdf-layout.component.scss"],"names":[],"mappings":"AAAA;EACI,YAAA;EACA,YAAA;AACJ;;AAEC;EACI,YAAA;EACA,iBAAA;AACL;;AAOC;EACI,WAAA;EACA,kBAAA;EACA,YAAA;AAJL;;AAOG;EACC,0BAAA;AAJJ;;AAQG;EACE,YAAA;EACA,kBAAA;AALL;;AAQG;EACE,gBAAA;EACA,kBAAA;AALL;;AAQG;EACC,WAAA;EACA,YAAA;EACA,WAAA;AALJ;AACA,g6CAAg6C","sourcesContent":[".btn{\r\n    float: right;\r\n    margin: 10px;\r\n }\r\n \r\n .img-fluid{\r\n     float: right;\r\n     margin-left: 20px;\r\n }\r\n // table thead th { \r\n //     color: white;\r\n //      font-size:10pt;\r\n //       background-color: #3b5998\r\n //     }\r\n \r\n #date{\r\n     float: left;\r\n     font-style: italic;\r\n     margin:20px ;\r\n   }\r\n \r\n   .heading{\r\n    text-decoration: underline;\r\n   }\r\n \r\n  \r\n   .file{\r\n     margin: 20px;\r\n     text-align: center;\r\n   }\r\n \r\n   .fileheading{\r\n     margin-top: 30px;\r\n     text-align: center;\r\n \r\n   }\r\n   .row{\r\n    float: left;\r\n    margin: 20px;\r\n    border: 2px;\r\n   }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
